'use client';
import Loading from '@components/Loading';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import OrderSummary from '@components/Cart/_OrderSummary';
import useBasket from '@hooks/basket/useBasket';
import GiftCardLineItem from '@components/Cart/_GiftCardLineItem';
import SingleLineItem from './_SingleLineItem';

interface Props {
  isEmpty: boolean;
  cartEmptyMessage?: string;
  outOfStockItems?: Array<string>;
  setDisabled?: boolean;
}

const CartBody = ({ isEmpty, outOfStockItems }: Props) => {
  const { data: basket, isLoading } = useBasket();
  const { t } = useTranslation();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      {isEmpty ? (
        <div className="tw-h-15 tw-w-full tw-bg-surface-200 tw-px-4 tw-flex tw-justify-center tw-items-center tw-mt-8">
          <p className="tra-text-web-body-xl tw-mb-0">
            {t('cart.cartEmptyMessage', undefined, { default: 'Your cart is currently empty.' })}
          </p>
        </div>
      ) : (
        <>
          <div>
            <ul className="tw-list-none tw-p-0">
              {!isLoading &&
                basket?.lineItems.map((product, i) => (
                  <SingleLineItem
                    key={i}
                    lineItem={product}
                    outOfStock={outOfStockItems?.includes(product.sku)}
                  />
                ))}
              {basket?.giftCards?.map((giftCard) => (
                <GiftCardLineItem giftCard={giftCard} editable key={`Gift_Card_${giftCard.id}`} />
              ))}
            </ul>
          </div>
          <div className="tw-pt-8">
            <OrderSummary />
          </div>
        </>
      )}
    </div>
  );
};

export default CartBody;
